// Theme.js version 1.0.1
// Use PrePros's Concat Js option to automatically prepend global.js at the beginning of this file.
// @prepros-prepend global.js

// Place any custom Javascript or jQuery in this file.
// If code needs to wait until the DOM is ready, place within the jQuery function below.
(function ($) {
	// Variables and DOM Caching.
	// var $window = $(window);

	var heroText = $(".hero-text-anim");
	console.log(heroText);

	setTimeout(function () {
		// for(let i = 0 ; i <= heroText.length ; i++) {
		// 	setTimeout(function() {
		// 		heroText[i].addClass("start");
		// 	  }, 500);
		// }

		heroText.each(function (i, elem) {
			setTimeout(function () {
				// console.log("working");
				$(elem).addClass("start");
			}, 500 * i);
		});
	}, 900);

	// Use scrollTo.js to animate banner button scrolling.
	// If put into use, be sure to uncomment in lib/custom-functions.php as well.
	$(".scroll-to-anchor").click(function (e) {
		if (e.currentTarget.hash) {
			e.preventDefault();

			$(window).scrollTo(e.currentTarget.hash, { duration: 600 });
		}
	});

	// Quick function for smooth scroll anchor links down the page
	$('a[href^="#"]').click(function (event) {
		// Ignore on product tabs, also ignore carousels
		if (
			$(this).parents("ul.tabs").length == 0 &&
			$(this).parents(".carousel").length == 0
		) {
			event.preventDefault();

			var anchor = $(this).attr("href");

			window.scrollTo({
				top: $(anchor).offset().top,
				behavior: "smooth",
			});

			return false;
		}
	});

	// Main modal menu wrapping submenus
	var $mainSubMenus = $("#top-menu .sub-menu");

	$mainSubMenus.wrap(
		"<div class='sub-menu-wrapper-circle'><div class='sub-menu-adjustable-wrapper'></div></div>"
	);

	$mainSubMenus.prepend("<div class='menu-curve-guide'></div>");

	var curves = $(".menu-curve-guide");
	var subMenuScrollers = $(".sub-menu");

	for (let i = 0; i < subMenuScrollers.length; i++) {
		subMenuScrollers[i].addEventListener("scroll", function () {
			curves[i].style.marginTop = this.scrollTop + "px";
		});
	}

	// Main modal menu wrapping submenus for accordions and connecting main li with each submenu
	var $mainMenusMobile = $("#top-menu-mobile > li");
	var $mainMenusMobileLink = $("#top-menu-mobile > li > a");
	var $mainSubMenusMobile = $("#top-menu-mobile .sub-menu");
	// console.log($mainSubMenusMobile[1]);

	$mainMenusMobileLink.addClass("mobile-accordion-menu__button h4 collapsed");

	$mainMenusMobile.addClass("mobile-accordion-menu__wrapper");

	$("#top-menu-mobile .sub-menu").each(function (index) {
		$(this).wrap(
			"<div id='mobileMenu" +
				index +
				"' class='mobile-accordion-menu__links collapse' data-bs-parent='#accordion'></div>"
		);
	});

	$mainMenusMobileLink
		.filter(function (i) {
			return $(this).next().length === 1;
		})
		.each(function (index) {
			$(this).click(function (e) {
				// console.log($(this).parent().next().length);
				if ($(this).parent().next().length) {
					e.preventDefault();
				}
			});

			$(this).wrap("<div class='mobile-accordion-menu__row'></div>");
			$(this).attr("data-bs-toggle", "collapse");
			$(this).attr("data-bs-target", "#mobileMenu" + index + "");
			$(this).attr("aria-controls", "mobileMenu" + index + "");
			$(this).attr("aria-expanded", "false");
			$(this).append("<span class='line'></span><span class='chevron'></span>");
		});

	// Animate new banner content
	var $revisedBanner = $(".revised-banner");

	if ($revisedBanner.length) {
		setTimeout(function () {
			$revisedBanner.removeClass("anim-scheduled");
		}, 500);
	}

	// Set/clear cookie for Newsletter signup box.
	if (!$.cookie("signup-hide")) {
		$(".signup-notice").removeClass("signup-hide");
	}

	$(".signup-notice .trigger-cookie").click(function (e) {
		$.cookie("signup-hide", "hide", { expires: 7, path: "/" });
		$(".signup-notice").addClass("signup-hide").remove();
	});

	// Pathway Tool triggers
	var $launch = $("#launch-pathways"),
		$linkItems = $(".pathway-list__item"),
		$modal = $("#pathway-modal"),
		$start = $(".pathway-start"),
		$selectors = $(".pathway-selectors"),
		$slides = $(".pathway-slides");

	// Only set up the triggers if on the Pathways page
	if ($launch.length) {
		// Transition betweens slides 1 & 2
		$launch.click(function () {
			// console.log('1 > 2');
			$start.addClass("inactive");
			$selectors.removeClass("inactive");
		});

		// Hook into the carousel to animate between slides 2 & 3
		$linkItems.click(function () {
			// $selectors.addClass('inactive');
			// $slides.removeClass('inactive');

			$modal.modal("show");
		});

		// $modal.on('hide.bs.modal', function() {
		// 	$selectors.removeClass('inactive');
		// });
	}

	// Reset scroll position when pathway carousel navigates
	$modal.on("slide.bs.carousel", function () {
		setTimeout(function () {
			$modal.scrollTop(0);
		}, 300);
	});

	// Campus Locations filter tech
	var $sectorSelect = $("#sector-select"),
		$regionSelect = $("#region-select"),
		$accordions = $(".offering-colleges__accordion"),
		$resultsMsg = $(".campus-filters__results");

	$("#campus-filters__submit").click(function (e) {
		// Shouldn't need this, but tossing in just to ensure we don't accidentally attempt a form submit.
		e.preventDefault();

		// Clear the plate by making all campuses inactive to start
		$accordions.addClass("inactive");

		// Then test the select field values.
		if ($sectorSelect.val() == "" && $regionSelect.val() == "") {
			// If both come back as false/not selected, bring all campuses back into view.
			$accordions.removeClass("inactive");
		} else if ($sectorSelect.val() && $regionSelect.val()) {
			// If both are set, then filter the two in tandem (show campuses that only qualify for both results)
			$accordions
				.filter("." + $sectorSelect.val() + "." + $regionSelect.val())
				.removeClass("inactive");
		} else {
			// Lastly, apply the filters to one or the other.
			if ($sectorSelect.val()) {
				$accordions.filter("." + $sectorSelect.val()).removeClass("inactive");
			}
			if ($regionSelect.val()) {
				$accordions.filter("." + $regionSelect.val()).removeClass("inactive");
			}
		}

		if ($accordions.filter(".inactive").length == $accordions.length) {
			$resultsMsg.removeClass("inactive");
		} else {
			$resultsMsg.addClass("inactive");
		}

		// Same reason as preventDefault for this.
		return false;
	});

	// Reset link for filters
	$("#campus-filters__clear").click(function () {
		$accordions.removeClass("inactive");
		$resultsMsg.addClass("inactive");
		$sectorSelect.val("");
		$regionSelect.val("");
	});
})(jQuery);
